import { leaderboardEnabled } from "@/src/services/api/leaderboard/leaderboard-functions";
import { useRecordShare } from "@/src/services/api/leaderboard/leaderboard.hooks";

/**
 * Reports a completed post share to the leaderboard. The server credits it at most once per
 * user and post and never for one's own post; reactions and comments need no client call
 * because the server derives them from the stored interactions (web and Selisian alike).
 */
export const useShareWithPoints = () => {
  const { mutate } = useRecordShare();
  const handleSharedSuccessfully = (postId?: string) => {
    if (!postId || !leaderboardEnabled) return;
    mutate(postId);
  };
  return { handleSharedSuccessfully };
};
